(function() {
	"use strict"

	angular.module( "ATMGurus" )

	.directive( 'pdfDownload', [
		"ApiQuery",
		"ErrorService",
		"$window",
		"$rootScope",
		function( ApiQuery, ErrorService, $window, $rootScope ) {
			return {
				restrict: "AE",
				scope: {
					'invoice': '=',
				},
				link: function( scope, ele, attrs ) {
					var link = $("<a>").attr( { "href": "#" }).text( "Download" );

					link.bind( "click", function( event ) {
						event.preventDefault();
						$rootScope.$broadcast( "modal.open", { title: "Fetching Invoice", data: { message: "Fetching Invoice #" + scope.invoice } } )
						ApiQuery( "customer/invoice/" + scope.invoice, "", "GET" )
							.then( function( response ) {
								$rootScope.$broadcast( "modal.close" );
								$window.open( 'data:application/pdf;base64,' + response )
							}, function( reason ) {
								ErrorService.set( "applicationWide", reason.message );
							})
					} )
					ele.append( link );
				}
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/directives/pdfDownload.js